import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const CardsIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <rect width="7" height="7" fill={color} />
    <rect x="9" width="7" height="7" fill={color} />
    <rect x="9" y="9" width="7" height="7" fill={color} />
    <rect y="9" width="7" height="7" fill={color} />
  </svg>
);

CardsIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

CardsIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(16, 16),
};

export default CardsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/cards.js